import { motion } from 'framer-motion';
import styled from 'styled-components';
import { DailyBonusProductProps } from '../types';

const StyledProduct = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: end;
    align-items: center;

    img {
        height: 120px;
        object-fit: contain;
        filter: drop-shadow(0 0 0.75rem rgb(255, 255, 255, 0.5));
    }
`;

const StyledProductText = styled.span`
    font-size: 20px;
    color: ${(props: any) => props.color};
    font-weight: bold;
    text-shadow: 1px 1px 3px #693510, -1px -1px 3px #693510,
        1px -1px 3px #693510, -1px 1px 3px #693510;
    display: flex;
    align-items: center;
    gap: 4px;
    margin-top: 8px;
    margin-right: 5px;

    &:last-child {
        margin-right: 0;
    }

    img {
        height: 20px;
        width: 20px;
    }
`;

function PopupSingleProduct({
    images,
    quantityDisplay,
    textColor
}: DailyBonusProductProps) {
    return (
        <StyledProduct>
            <motion.img
                src={images.product}
                alt="product"
                animate={{ x: [1, -1.5, 1.5, 1], y: [1, 1.5, -1.5, 1] }}
                transition={{ repeat: Infinity, duration: 2 }}
            />
            <StyledProductText color={textColor}>
                {images.productPrefix && (
                    <img src={images.productPrefix} alt="prefix" />
                )}
                {quantityDisplay}
            </StyledProductText>
        </StyledProduct>
    );
}

export default PopupSingleProduct;
